export default __webpack_public_path__ + "static/media/blue-check.cb9acdb5.svg";